module.exports = __webpack_public_path__ + "img/partido-politico-contigo.970edb6e.png";